const DEVICE_ID_KEY = "device_id";

/**
 * Ambil device_id yang sudah tersimpan, atau generate baru kalau belum ada.
 * device_id ini yang dipakai buat nandain siapa yang like/komen/submit aspirasi,
 * jadi harus konsisten selama browser/device yang sama dipakai.
 */
export function getDeviceId(): string {
  try {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);

    if (!deviceId) {
      deviceId = generateUUID();
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }

    return deviceId;
  } catch {
    // localStorage diblokir (mode incognito ketat dll), fallback ke ID sementara
    // (tidak persist antar reload, tapi minimal fitur tetap jalan di 1 sesi)
    return generateUUID();
  }
}

function generateUUID(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback buat browser lama yang gak support crypto.randomUUID
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
